// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/black_hat.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { BlackHatAssessmentContent, BlackHatAssessmentVersion, BlackHatScenarioInput } from "../../datagateway/v1/black_hat_pb";
/**
 * Browser requests derive tenant and actor solely from the authenticated principal.
 *
 * @generated from message mono.projectdata.v1.ListBlackHatAssessmentsRequest
 */ export class ListBlackHatAssessmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListBlackHatAssessmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBlackHatAssessmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBlackHatAssessmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBlackHatAssessmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pursuit_id = 1;
   */ _define_property(this, "pursuitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBlackHatAssessmentsRequest, "runtime", proto3);
_define_property(ListBlackHatAssessmentsRequest, "typeName", "mono.projectdata.v1.ListBlackHatAssessmentsRequest");
_define_property(ListBlackHatAssessmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListBlackHatAssessmentsResponse
 */ export class ListBlackHatAssessmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListBlackHatAssessmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBlackHatAssessmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBlackHatAssessmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBlackHatAssessmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.BlackHatAssessmentVersion assessments = 1;
   */ _define_property(this, "assessments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBlackHatAssessmentsResponse, "runtime", proto3);
_define_property(ListBlackHatAssessmentsResponse, "typeName", "mono.projectdata.v1.ListBlackHatAssessmentsResponse");
_define_property(ListBlackHatAssessmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessments",
            kind: "message",
            T: BlackHatAssessmentVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveBlackHatAssessmentVersionRequest
 */ export class SaveBlackHatAssessmentVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveBlackHatAssessmentVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveBlackHatAssessmentVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveBlackHatAssessmentVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveBlackHatAssessmentVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pursuit_id = 1;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string participant_id = 2;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: int32 expected_version = 3;
   */ _define_property(this, "expectedVersion", 0), /**
   * @generated from field: mono.datagateway.v1.BlackHatAssessmentContent content = 4;
   */ _define_property(this, "content", void 0), /**
   * @generated from field: repeated string evidence_ids = 5;
   */ _define_property(this, "evidenceIds", []), /**
   * @generated from field: repeated mono.datagateway.v1.BlackHatScenarioInput scenarios = 6;
   */ _define_property(this, "scenarios", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveBlackHatAssessmentVersionRequest, "runtime", proto3);
_define_property(SaveBlackHatAssessmentVersionRequest, "typeName", "mono.projectdata.v1.SaveBlackHatAssessmentVersionRequest");
_define_property(SaveBlackHatAssessmentVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expected_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "content",
            kind: "message",
            T: BlackHatAssessmentContent
        },
        {
            no: 5,
            name: "evidence_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "scenarios",
            kind: "message",
            T: BlackHatScenarioInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveBlackHatAssessmentVersionResponse
 */ export class SaveBlackHatAssessmentVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveBlackHatAssessmentVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveBlackHatAssessmentVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveBlackHatAssessmentVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveBlackHatAssessmentVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BlackHatAssessmentVersion assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveBlackHatAssessmentVersionResponse, "runtime", proto3);
_define_property(SaveBlackHatAssessmentVersionResponse, "typeName", "mono.projectdata.v1.SaveBlackHatAssessmentVersionResponse");
_define_property(SaveBlackHatAssessmentVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: BlackHatAssessmentVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetBlackHatAssessmentHistoryRequest
 */ export class GetBlackHatAssessmentHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetBlackHatAssessmentHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBlackHatAssessmentHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBlackHatAssessmentHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBlackHatAssessmentHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pursuit_id = 1;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string participant_id = 2;
   */ _define_property(this, "participantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBlackHatAssessmentHistoryRequest, "runtime", proto3);
_define_property(GetBlackHatAssessmentHistoryRequest, "typeName", "mono.projectdata.v1.GetBlackHatAssessmentHistoryRequest");
_define_property(GetBlackHatAssessmentHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetBlackHatAssessmentHistoryResponse
 */ export class GetBlackHatAssessmentHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetBlackHatAssessmentHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBlackHatAssessmentHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBlackHatAssessmentHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBlackHatAssessmentHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.BlackHatAssessmentVersion versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBlackHatAssessmentHistoryResponse, "runtime", proto3);
_define_property(GetBlackHatAssessmentHistoryResponse, "typeName", "mono.projectdata.v1.GetBlackHatAssessmentHistoryResponse");
_define_property(GetBlackHatAssessmentHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: BlackHatAssessmentVersion,
            repeated: true
        }
    ]));
